export enum ePermissions {
  AdminEdit = 'ADMIN_EDIT',
  AdminRead = 'ADMIN_READ',
  AuthIdentityEdit = 'AUTH_IDENTITY_EDIT',
  AuthIdentityRead = 'AUTH_IDENTITY_READ',
  AuthPermissionGroupEdit = 'AUTH_PERMISSION_GROUP_EDIT',
  AuthPermissionGroupRead = 'AUTH_PERMISSION_GROUP_READ',
  AuthRoleEdit = 'AUTH_ROLE_EDIT',
  AuthRoleRead = 'AUTH_ROLE_READ',
  ClientCompanyEdit = 'edit:client-company',
  CommentsEdit = 'edit:comments',
  CommentsRead = 'read:comments',
  CompletedTasksEdit = 'edit:order.order-tasks.completed',
  ContactInternalEdit = 'CONTACT_INTERNAL_EDIT',
  ContactInternalRead = 'CONTACT_INTERNAL_READ',
  EditExternalEmail = 'edit:external-email',
  DiscountsRead = 'DISCOUNTS_READ',
  DiscountsEdit = 'DISCOUNTS_EDIT',
  EscrowFilesEdit = 'ESCROW_FILES_EDIT',
  EscrowFilesRead = 'ESCROW_FILES_READ',
  EscrowFileCdItemsEdit = 'ESCROW_FILE_CD_ITEMS_EDIT',
  EscrowFileCdItemsRead = 'ESCROW_FILE_CD_ITEMS_READ',
  EscrowExpectedIncomingChecksRead = 'ESCROW_EXPECTED_INCOMING_CHECKS_READ',
  EscrowExpectedIncomingWiresRead = 'ESCROW_EXPECTED_INCOMING_WIRES_READ',
  EscrowExpectedAchPullDepositsRead = 'ESCROW_EXPECTED_ACH_PULL_DEPOSITS_READ',
  EscrowExpectedIncomingChecksEdit = 'ESCROW_EXPECTED_INCOMING_CHECKS_EDIT',
  EscrowExpectedIncomingWiresEdit = 'ESCROW_EXPECTED_INCOMING_WIRES_EDIT',
  EscrowExpectedAchPullDepositsEdit = 'ESCROW_EXPECTED_ACH_PULL_DEPOSITS_EDIT',
  EscrowActualIncomingChecksEdit = 'ESCROW_ACTUAL_INCOMING_CHECKS_EDIT',
  EscrowActualIncomingChecksRead = 'ESCROW_ACTUAL_INCOMING_CHECKS_READ',
  EscrowActualIncomingWiresEdit = 'ESCROW_ACTUAL_INCOMING_WIRES_EDIT',
  EscrowActualIncomingWiresRead = 'ESCROW_ACTUAL_INCOMING_WIRES_READ',

  EscrowActualAchDepositsEdit = 'ESCROW_ACTUAL_ACH_DEPOSITS_EDIT',
  EditEscrowActualAchPushDepositsDisbursed = 'edit:escrow.actual-ach-deposits-disbursed',
  EscrowActualAchDepositsRead = 'ESCROW_ACTUAL_ACH_DEPOSITS_READ',

  EscrowInternalTransfersEdit = 'ESCROW_INTERNALTRANSFERS_EDIT',
  EditEscrowInternalTransfersDisbursed = 'edit:escrow.internal-transfers-disbursed',
  EscrowInternalTransfersRead = 'ESCROW_INTERNALTRANSFERS_READ',

  EscrowInternalTransfersRestrictedRead = 'ESCROW_INTERNALTRANSFERS_RESTRICTED_READ',
  EscrowJournalEntriesEdit = 'ESCROW_JOURNALENTRIES_EDIT',
  EscrowJournalEntriesRead = 'ESCROW_JOURNALENTRIES_READ',
  EscrowCheckDisbursementsEdit = 'ESCROW_CHECK_DISBURSEMENTS_EDIT',
  EscrowCheckDisbursementsRead = 'ESCROW_CHECK_DISBURSEMENTS_READ',
  EscrowCheckIssuanceDateEdit = 'edit:escrow.check.issuance-date',
  EscrowExpectedAchPushDepositsEdit = 'ESCROW_EXPECTED_ACH_PUSH_DEPOSITS_EDIT',
  EscrowExpectedAchPushDepositsRead = 'ESCROW_EXPECTED_ACH_PUSH_DEPOSITS_READ',
  EscrowExpectedInternalTransfersEdit = 'ESCROW_EXPECTED_INTERNAL_TRANSFERS_EDIT',
  EscrowExpectedInternalTransfersRead = 'ESCROW_EXPECTED_INTERNAL_TRANSFERS_READ',
  EscrowManualCheckDisbursementsEdit = 'ESCROW_MANUAL_CHECK_DISBURSEMENTS_EDIT',
  EscrowManualCheckDisbursementsRead = 'ESCROW_MANUAL_CHECK_DISBURSEMENTS_READ',

  EscrowWireDisbursementsEdit = 'ESCROW_WIRE_DISBURSEMENTS_EDIT',
  EditEscrowWireDisbursementsDisbursed = 'edit:escrow.wire-disbursements-disbursed',
  EscrowWireDisbursementsRead = 'ESCROW_WIRE_DISBURSEMENTS_READ',
  EscrowFundingCompletedEdit = 'edit:escrow.funding-completed',
  EditEscrowInitiateDisbursement = 'edit:escrow.initiate-disbursement',
  GIACTRead = 'read:giact',
  GIACTEdit = 'edit:giact',
  CdItemsV3Edit = 'CD_ITEMS_V3_EDIT',
  CdItemsV3Read = 'CD_ITEMS_V3_READ',
  OrderPartiesRead = 'ORDER_PARTIES_READ',
  OrderPropertyAddressRead = 'ORDER_PROPERTY_ADDRESS_READ',
  OrderRead = 'ORDER_READ',
  OrderUnderwriterEdit = 'ORDER_UNDERWRITER_EDIT',
  ORDER_EDIT = 'ORDER_EDIT',
  FeatureRead = 'FEATURE_READ',
  FeatureEdit = 'FEATURE_EDIT',
  LenderCompanyEdit = 'edit:lender-company',
  QuotesFeeEdit = 'QUOTES_FEE_EDIT',
  ReadClientPortal = 'read:client-portal',
  ReadVendorPortal = 'read:vendor-portal',
  ReadSellerPortal = 'read:seller-portal',
  ReadBorrowerPortal = 'read:borrower-portal',
  TagEdit = 'edit:tags',
  TransferDeedEdit = 'edit:transfer-deed',
}
